import React, {useContext, useState} from 'react';
import PropTypes from 'prop-types';
import {FormattedMessage} from "react-intl";

import {Radio, RadioGroup} from "@mui/material";

import CustomButton from "components/CustomButton";
import FormControlLabel from "components/radioGroup/FormControlLabel";

import DrawerSelector from "./components/DrawerSelector";

import {PackingContext} from "../../../PackingContext";

import {itemCancelled} from "api/wms/wmsItems/wmsItems";

import {getTranslation} from "../../../../../../../../domain/helpers/translations";

ProductProblemDrawer.propTypes = {
    open: PropTypes.bool.isRequired,
    handleClose: PropTypes.func.isRequired,
    product: PropTypes.object.isRequired,
    handleProductCancelled: PropTypes.func.isRequired
};

function ProductProblemDrawer({open, handleClose, product, handleProductCancelled}) {
    const [choiceValue, setChoiceValue] = useState(null)

    const {cancellationReasons} = useContext(PackingContext);

    const handleValid = (choiceValue) => {
        itemCancelled(product.wmsItem.id, choiceValue, true).then(() => {
            handleProductCancelled(product.wmsItem.id)
        })
    }

    if (!open || !cancellationReasons) {
        return (<></>)
    }

    return (
        <DrawerSelector
            open={open}
            handleClose={handleClose}
        >
            <div>
                <RadioGroup
                    onChange={(event) => setChoiceValue(event.target.value)}
                    value={choiceValue}
                >
                    {cancellationReasons.map((productProblem) => (
                        <FormControlLabel
                            control={<Radio/>}
                            label={getTranslation(productProblem).name}
                            value={productProblem.id}
                            sx={{
                                display: "flex",
                                justifyContent: "space-between",
                                margin: 0,
                                padding: "16px",
                                border: 'unset',
                            }}
                        />
                    ))}
                </RadioGroup>
                <div style={{ padding: "16px" }}>
                    <CustomButton
                        fullWidth
                        disabled={choiceValue === null}
                        onClick={() => handleValid(choiceValue)}
                    >
                        <FormattedMessage id={"wms.packing.productProblem.validButton"}/>
                    </CustomButton>
                </div>
            </div>
        </DrawerSelector>
    );
}

export default ProductProblemDrawer;
